export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Second Page',
        route: 'second-page',
        icon: 'FileIcon',
      },
      {
        title: 'Dependencia',
        route: 'Dependencia',
        icon: 'FileIcon',
      },
      {
        title: 'Menu',
        route: 'Menu',
        icon: 'FileIcon',
      },
    ],
  },
]
